module.exports = __webpack_public_path__ + "img/3_165.5acdf1a0.png";